'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Flashlight;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Flashlight(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-flashlight ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'g',
      { fill: color, fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M15.12 3.987l-1.914.513a.416.416 0 1 0 .216.804l1.913-.513a.415.415 0 0 0 .1-.762.414.414 0 0 0-.316-.042M13.563 1.901l-1.718 1.718a.417.417 0 0 0 .588.589l1.718-1.718a.417.417 0 0 0-.588-.589M11.359 3.1a.416.416 0 0 0 .194-.253l.512-1.913a.417.417 0 0 0-.804-.215l-.512 1.912a.412.412 0 0 0 .041.316.412.412 0 0 0 .569.152M6.899 4.862l4.292 4.292a2.132 2.132 0 0 1-2.194.342L8.52 9.3l-5.384 5.385-1.767-1.767 5.385-5.384-.197-.478A2.132 2.132 0 0 1 6.9 4.862zm4.89 3.713l.812-.811-4.312-4.312-.811.812 4.312 4.311zM7.932 2.633L6.436 4.128a2.974 2.974 0 0 0-.664 3.21L4.726 8.384l-.34-.339-1.67 1.671.339.339L.549 12.56a.507.507 0 0 0 0 .716l2.228 2.227a.507.507 0 0 0 .716 0l5.223-5.223a2.976 2.976 0 0 0 3.209-.664l1.495-1.495a.507.507 0 0 0 0-.716L8.647 2.633a.507.507 0 0 0-.716 0z' })
    )
  );
}

Flashlight.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Flashlight/Flashlight.js
// module id = 1191
// module chunks = 1